import React, { useEffect, useState } from "react";
import CardService from "../../../components/cardservice/CardService";
import axios from "axios";
import "./Ticket.scss";
import usePaginations from "../../../Paginations";
import { Pagination } from "@mui/material";
import Contant from "../../../Contant";

const PlaneTicket = (props) => {
  const [datas, setDatas] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios({
        method: "get",
        url: Contant + "api/posts?type=products",
        Headers: {
          Accept: "application.json",
          "Content-Type": "application/json",
        },
      });

      if (response.data.products.train_ticket === undefined) {
        setDatas(datas);
      } else {
        setDatas(response.data.products.train_ticket);
      }
    };
    fetchData();
  }, [props]);

  let [page, setPage] = useState(1);
  const PER_PAGE = 6;

  const count = Math.ceil(datas.length / PER_PAGE);
  var _DATA = usePaginations(datas, PER_PAGE);

  // console.log(_DATA)

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  return (
    <div className="Main_style_serviceTop_element_ticket">
      <div className="style_frame_main_cardss_service">
        <div className="frame_service_items">
          {_DATA.currentDatas().map((item, index) => (
            <div key={index}>
              <CardService
                Title={item.title}
                image={
                  "https://tiendungfinance.com.vn/api/data/images/" +
                  item.coverPhoto
                }
                date={item.date}
                id={item.id}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="frame_piantion">
        <Pagination
          count={count}
          size="small"
          page={page}
          variant="outlined"
          shape="rounded"
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default PlaneTicket;
